//Functions
import { App as ControlledMin } from './ControlledMin/appDeclaration'
import { App as ControlledMax } from './ControlledMax/appDeclaration'
import { App as ControlledMaxRequest } from './ControlledMaxRequest/appDeclaration'
import { App as IControlledHeatingOutletRelease } from './Heatings/ControlledHeatingOutletRelease/appDeclaration'
import { App as IControlledHeatingOutletPumpControl } from './Heatings/ControlledHeatingOutletPumpControl/appDeclaration'
import { App as IControlledCoolingOutletRelease } from './Coolings/ControlledCoolingOutletRelease/appDeclaration'
import { App as IControlledCoolingOutletPumpControl } from './Coolings/ControlledCoolingOutletPumpControl/appDeclaration'

export const Apps = {
    [ControlledMin.schema]: ControlledMin,
    [ControlledMax.schema]: ControlledMax,
    [ControlledMaxRequest.schema]: ControlledMaxRequest,
    [IControlledHeatingOutletRelease.schema]: IControlledHeatingOutletRelease,
    [IControlledHeatingOutletPumpControl.schema]: IControlledHeatingOutletPumpControl,
    [IControlledCoolingOutletRelease.schema]: IControlledCoolingOutletRelease,
    [IControlledCoolingOutletPumpControl.schema]: IControlledCoolingOutletPumpControl,
}